import { render, staticRenderFns } from "./SimpleTextDialog.vue?vue&type=template&id=4624fc84&scoped=true&"
import script from "./SimpleTextDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleTextDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextDialog.vue?vue&type=style&index=0&id=4624fc84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624fc84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VDialog,VProgressLinear})
